var _rect, _circle, _rect2, _circle2, _rect3, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationalParamsDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 49,
    viewBox: "0 0 84 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 8,
    width: 2,
    height: 33,
    rx: 1,
    fill: "#605CFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 32,
    r: 3.5,
    fill: "#D2DFFA",
    stroke: "#1A202C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 8,
    width: 2,
    height: 33,
    rx: 1,
    fill: "#BECDFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 17,
    r: 3.5,
    fill: "#D2DFFA",
    stroke: "#1A202C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 8,
    width: 2,
    height: 33,
    rx: 1,
    fill: "#FF6565"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 25,
    r: 3.5,
    fill: "#D2DFFA",
    stroke: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationalParamsDark);
export default __webpack_public_path__ + "static/media/operational-params-dark.f229d2abdf202eb22a8953b6f99bcaac.svg";
export { ForwardRef as ReactComponent };